// @ts-ignore
import { Form } from 'mobx-react-form';
// @ts-ignore
import dvr from 'mobx-react-form/lib/validators/DVR';
// @ts-ignore
import validatorjs from 'validatorjs';
import { SiteIntegrationMethodEnum } from '@beable/roster-backend-client-v1';


interface IForm {
  values(): any;

  errors(): any;

  $(): any;
}

export class CustomerSetupOneRosterCSVForm extends Form {
  plugins() {
    return {
      dvr: dvr(validatorjs)
    };
  }

  setup() {
    return {
      fields: [
        {
          name: 'integrationMethod',
          label: 'Select Integration Method',
          placeholder: 'Select Integration Method',
          rules: 'required',
          value: SiteIntegrationMethodEnum.Manual
        }
      ]
    };
  }

  hooks() {
    return {
      onSuccess(form: IForm) {
        console.log('Form is valid! Send the request here.');
        // get field values
        console.log('Form Values!', form.values());
      },
      onError(form: IForm) {
        console.log('Form has errors!');
        // get all form errors
        console.log('All form errors', form.errors());
      }
    };
  }
}

export class CustomerSetupOneRosterAPIForm extends Form {
  plugins() {
    return {
      dvr: dvr(validatorjs)
    };
  }

  setup() {
    return {
      fields: [
        {
          name: 'integrationMethod',
          label: 'Integration Method',
          placeholder: 'Select Integration Method',
          rules: 'required',
          value: SiteIntegrationMethodEnum.Manual
        },
        {
          name: 'provider',
          label: 'Provider',
          placeholder: 'Select Provider',
          rules: 'required'
        },
        {
          name: 'applicationId',
          label: 'Application Id',
          placeholder: 'Select Application Id',
          rules: 'required'
        },
        {
          name: 'token',
          label: 'Token',
          placeholder: 'Token',
          rules: 'required'
        }
      ]
    };
  }

  hooks() {
    return {
      onSuccess(form: IForm) {
        console.log('Form is valid! Send the request here.');
        // get field values
        console.log('Form Values!', form.values());
      },
      onError(form: IForm) {
        console.log('Form has errors!');
        // get all form errors
        console.log('All form errors', form.errors());
      }
    };
  }
}

export class CustomerSetupCleverAPIForm extends Form {
  plugins() {
    return {
      dvr: dvr(validatorjs)
    };
  }

  setup() {
    return {
      fields: [
        {
          name: 'integrationMethod',
          label: 'Integration Method',
          placeholder: 'Select Integration Method',
          rules: 'required',
          value: SiteIntegrationMethodEnum.Manual
        },
        {
          name: 'token',
          label: 'Token',
          placeholder: 'Token',
          rules: 'required'
        },
        {
          name: 'disableSchedule',
          label: 'Disable schedule',
          placeholder: 'Disable schedule',
          rules: ''
        }
      ]
    };
  }

  hooks() {
    return {
      onSuccess(form: IForm) {
        console.log('Form is valid! Send the request here.');
        // get field values
        console.log('Form Values!', form.values());
      },
      onError(form: IForm) {
        console.log('Form has errors!');
        // get all form errors
        console.log('All form errors', form.errors());
      }
    };
  }
}
